import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

export default function DynamicFormDefaultWidget({ module }) {
  return (
    <DefaultWidgetTemplate
      module={module}
      route="user_module_dynamicForm_home"
    />
  );
}
